import { useComponentLoadingStateStore } from "../../store/useComponentLoadingStateStore";
import { useRouterStore } from "../../store/useRouterStore";
import Image from "next/image";
import { EXHIBITORS_MAP } from "../../configs/NAVIGATION_PAGES";
import { FooterWrapper } from "./NavigationCustomComponents";
import { Button, Slider } from "@mui/material";
import { useState } from "react";
import SingleBoothViewFiberComponent from "../fiber-components/SingleBoothViewFiberComponent";
import MapIconSVG from "../GenericLayout/MapIconSVG";
import BackButtonSVG from "../GenericLayout/BackButtonSVG";
import { debounce } from "../../helpers/debounce";
import { SimpleBox } from "../MaterialCustomComponents";
import { replaceBoothURL } from "../../helpers/updateBoothURL";
import { closeAllNavMenus } from "../../helpers/closeAllNavMenus";
import BoothInfoComponent from "../GenericLayout/BoothInfoComponent";

const FooterSection = ({ isDeviceOnLandscape = false }) => {
  const { setActiveCategory, boothID, setBoothID } = useRouterStore();
  const {
    setIsSideNavOpen,
    setIsMenuExpanded,
    setIsBurgerOpen,
    setIsInfoCategoryClicked,
    hallZoomValue,
    setHallZoomValue,
    isBoothVisitPartActive,
    setIsSingleBoothViewButtonPressed,
    setIsVideoClicked,
    setIsBoothContactFormOpen,
    areControlPanelButtonsDisabled,
    setIsZoomSelected,
    setIsVideoCategoryClicked,
  } = useComponentLoadingStateStore();
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  const handleOpenMapClick = () => {
    setIsSideNavOpen(true);
    setIsMenuExpanded(true);
    setActiveCategory(EXHIBITORS_MAP);
    setIsBurgerOpen(true);
  };

  const handleBackButtonClick = () => {
    setIsVideoCategoryClicked(false);
    setIsVideoClicked(false);
    setIsInfoOpen(false);
    if (isBoothVisitPartActive) {
      setIsSingleBoothViewButtonPressed(true);
      return;
    }
    replaceBoothURL();
    setHallZoomValue(0);
    setBoothID("");
    setIsVideoClicked(false);
  };

  const handleInfoClick = (category: string | undefined = undefined) => {
    setIsInfoOpen(!isInfoOpen);
    closeAllNavMenus();
    if (category === "contact") {
      setIsBoothContactFormOpen(true);
      return;
    }
    if (category === "brochures") {
      setIsVideoCategoryClicked(false);
    }
    if (category === undefined) {
      setIsInfoCategoryClicked("");
      return;
    }
    setIsInfoCategoryClicked(category);
  };

  const handleZoomChange = (e: any) => {
    setHallZoomValue(e.target.value);
  };

  return (
    <FooterWrapper>
      <SimpleBox sx={{ display: "flex", gap: "1rem" }}>
        {boothID !== "" && (
          <Button
            variant="controlPanel"
            onClick={debounce(handleBackButtonClick)}
          >
            <BackButtonSVG />
          </Button>
        )}
        <Button
          variant="controlPanel"
          onClick={() => handleOpenMapClick()}
          sx={{
            display: !boothID ? "flex" : "none",
            width: isDeviceOnLandscape ? "20px" : null,
            height: isDeviceOnLandscape ? "40px" : null,
          }}
          disabled={areControlPanelButtonsDisabled ? true : false}
        >
          <MapIconSVG />
        </Button>

        {!boothID && !areControlPanelButtonsDisabled && (
          <SimpleBox
            sx={{
              pointerEvents: "auto",
              backgroundColor: "rgba(0, 0, 0)",
              width: "10rem",
              padding: "0rem 1rem",
              height: isDeviceOnLandscape ? "40px" : "64px",
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              opacity: 0.4,
            }}
          >
            <Image
              src="/zoom.png"
              alt="map icon"
              width={30}
              height={30}
              style={{ pointerEvents: "auto" }}
              onClick={() => handleOpenMapClick()}
            />
            <Slider
              defaultValue={0}
              aria-label="Default"
              valueLabelDisplay="auto"
              value={hallZoomValue}
              marks={[
                { value: 0 },
                { value: 25 },
                { value: 50 },
                { value: 75 },
                { value: 100 },
              ]}
              step={25}
              onChange={(e) => handleZoomChange(e)}
              onTouchStart={() => setIsZoomSelected(true)}
              onTouchEnd={() => setIsZoomSelected(false)}
            />
          </SimpleBox>
        )}
      </SimpleBox>
      {boothID !== "" && (
        <BoothInfoComponent
          isInfoOpen={isInfoOpen}
          handleInfoClick={handleInfoClick}
          isMobile={true}
        />
      )}
    </FooterWrapper>
  );
};

FooterSection.r3f = () => {
  return <SingleBoothViewFiberComponent />;
};

export default FooterSection;
